module.exports = __webpack_public_path__ + "img/treatment1.f7d8ca23.svg";